import React, { useState } from "react";
import {IAnalysisFolder} from "./IAnalysisFolder";
import { FullAnalysisFolder } from "./FullAnalysisFolder";
import "./FullAnalysisFolderList.css";

interface IFullAnalysisFolderListProps {
    folder: IAnalysisFolder;
    selectedItem?: IAnalysisFolder;
    onSelect: (folder: IAnalysisFolder)=>void;
    onSettings?: (folder: IAnalysisFolder)=>void;
    onDelete: (folder: IAnalysisFolder, parent: IAnalysisFolder)=>void;
    onRename: (folder: IAnalysisFolder, newName: string)=>void;
    //onAdd: ()=>void;
    //onAddFile?: ()=>void;
}

export const FullAnalysisFolderList = ({folder, selectedItem, onSelect, onDelete, onRename, onSettings}: IFullAnalysisFolderListProps)=>{
    if (folder.type != 'folder' || !folder.folderItems){
        return;
    }
    
    const selectFolder = (folder: IAnalysisFolder)=>{
        onSelect(folder);
    }
    
    /*const handleAddFolder = ()=>{
        onAdd();
    }

    const handleAddFile = ()=>{
        onAddFile();
    }*/

    return <div className="FullAnalysis_files_block">
        <div className="FullAnalysis_files">
            {folder.folderItems.map(childFolder=><FullAnalysisFolder 
                key={childFolder.name + childFolder.id}
                folder={childFolder}
                className={`${childFolder == selectedItem ? "FullAnalysis_folder--selected" : ""}`}
                onDelete={(item)=>{
                    onDelete(item, folder);
                }}
                onRename={(newName)=>{onRename(childFolder, newName)}}
                onSettings={()=>{onSettings(childFolder)}}
                onSelect={()=>{
                    selectFolder(childFolder);
                }
            }></FullAnalysisFolder>)}
        </div>
        {/*<div className="dashboard_main_analysis_add">
            <div className="dashboard_main_analysis_add_icon">

            </div>
            <div className="button dashboard_main_analysis_add_text" onClick={handleAddFolder}>
                Add a new folder
            </div>
            {onAddFile && <div className="button dashboard_main_analysis_add_text" onClick={handleAddFile}>
                Upload file
            </div>}
        </div>*/}
    </div>
}